import { MdKeyboardArrowDown } from 'react-icons/md'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/@/components/ui/dropdown-menu'
import { useDossbotChatQuery, useDossbotChatsQuery } from '~/common/generated/apollo-operations'

interface DossbotChatSwitcherProps {
  chatId: string | null
  onChatSwitch: (chatId: string) => void
  hasAccess: boolean
}

export function DossbotChatSwitcher({ chatId, onChatSwitch, hasAccess }: DossbotChatSwitcherProps) {
  // Fetch current chat details to get the title
  const { data: chatData } = useDossbotChatQuery({
    variables: { chatId: chatId || '' },
    skip: !chatId || chatId.startsWith('temp-'),
  })

  // Fetch all chats for dropdown
  const { data: chatsData } = useDossbotChatsQuery({
    skip: !hasAccess,
  })

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <div className="min-w-0 flex-1 cursor-pointer rounded-md py-1 pe-2 ps-1 transition-colors">
          <div className="flex items-center gap-2">
            <div className="min-w-0 flex-1">
              <h3 className="my-2 truncate text-sm text-gray-10">
                {chatData?.dossbotChat.title || 'Dossbot'}
              </h3>
            </div>
            <MdKeyboardArrowDown
              className="transition-transform group-data-[state=open]:rotate-180"
              size={16}
            />
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        alignOffset={-8}
        className="z-[1500] max-h-60 w-80 overflow-auto"
        sideOffset={8}
      >
        {/* Chat List */}
        {chatsData?.dossbotChats.map((chat) => (
          <DropdownMenuItem
            key={chat.id}
            className={`gap-3 ${chatId === chat.id ? 'bg-blue-50' : ''}`}
            onSelect={() => onChatSwitch(chat.id)}
          >
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-medium">{chat.title || 'Untitled Chat'}</div>
              {chat.summary && (
                <div className="truncate text-xs text-muted-foreground">{chat.summary}</div>
              )}
            </div>
            {chatId === chat.id && <div className="bg-blue-500 ml-auto size-2 rounded-full" />}
          </DropdownMenuItem>
        ))}

        {/* Empty state */}
        {(!chatsData?.dossbotChats || chatsData.dossbotChats.length === 0) && (
          <div className="px-2 py-4 text-center text-sm text-muted-foreground">
            No chats yet. Start a conversation!
          </div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
